import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import QRCode from 'qrcode.react';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';

import styles from './NewsShare.module.scss';

/**
 * 新闻列表页分享组件
 * 与详情页 NewsShare 保持一致的外观，二维码指向当前页面 URL
 */
export default function NewsListShare() {
  const [popoverShow, setPopoverShow] = useState(false);
  const [currentUrl, setCurrentUrl] = useState('');
  const router = useRouter();
  const { t } = useTranslation('common');
  const { qrCodeText } = t('newsShareConfig', { returnObjects: true }) as { qrCodeText: string };

  // 客户端获取当前 URL（含分类参数），路由变化时重新生成
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentUrl(window.location.href);
    }
  }, [router.asPath]);

  return (
    <>
      <Head>
        <link rel="preload" as="image" href="https://s3plus.meituan.net/smart/sharewechat-hover.svg" />
      </Head>
      <div className="relative ml-6 h-fit rounded-[10px] border border-black-6 p-1">
        <div
          onFocus={() => 0}
          onMouseOver={() => setPopoverShow(true)}
          onMouseLeave={() => setPopoverShow(false)}
          className="h-12 w-12 cursor-pointer rounded-md bg-[url('https://s3plus.meituan.net/smart/sharewechat.svg')] bg-center bg-no-repeat hover:bg-black-5 hover:bg-[url('https://s3plus.meituan.net/smart/sharewechat-hover.svg')]"
        />
        <div className={classNames(styles.sharePopover, { [styles.show]: popoverShow })}>
          {currentUrl && <QRCode size={98} value={currentUrl} />}
          <div className={styles.shareText}>{qrCodeText || '微信扫码分享'}</div>
        </div>
      </div>
    </>
  );
}
